import RewardSimpleView from './RewardSimpleView'

export default RewardSimpleView
